import React, { ReactElement, useMemo } from 'react';

import { StickyCTA } from '../../../components/StickyCTA';
import { PATHS } from '../../../constants/paths';
import { SupplierSection } from '../../../types/supplier';

interface VerticalStickyCTAProps {
  suppliers?: SupplierSection;
  inLocation?: string;
  verticalName: string;
}

export function VerticalStickyCTA({
  suppliers,
  inLocation,
  verticalName,
}: VerticalStickyCTAProps): ReactElement {
  const isVenue = verticalName === 'Venues';
  const verticalTitle = isVenue ? 'venue' : 'supplier';

  const heading = useMemo(() => {
    if (!suppliers || suppliers.count < 4) {
      return `We have ${verticalTitle}s ready to quote`;
    }

    const supplierCountText = suppliers.outOfRange
      ? 'We have'
      : suppliers.count.toString();

    const pluralizedTitle =
      suppliers.count === 1 ? verticalTitle : `${verticalTitle}s`;
    const locationText = inLocation ? ` ${inLocation}` : '';

    return `${supplierCountText} ${pluralizedTitle}${locationText} ready to quote`;
  }, [suppliers, inLocation, verticalTitle]);

  return (
    <StickyCTA
      heading={heading}
      text="It only takes 2 minutes!"
      buttonText="Get quotes"
      buttonLink={PATHS.enquiryForm}
    />
  );
}
